import { css, SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { Link } from 'src/domains/layouts/webview/components/router/NewLink';
import { withConfig } from 'src/withConfig';

interface PriceLegendWrapperPropsType {
    isHomePage?: boolean;
    variant: DefaultComponentVariantType | null;
}

const setPriceLegendWrapper = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            margin-top: 8px;
            padding: ${theme.star.padding.xMedium} ${theme.star.padding.xMedium} 0;
        `;
    }
    return css`
        border: 1px solid ${theme.star.priceLegendList.borderColor};
        padding: ${theme.star.padding.medium} ${theme.star.padding.medium} 0;
    `;
};

export const PriceLegendWrapper = withConfig(theme => styled('div', { label: 'PriceLegendWrapper' })<PriceLegendWrapperPropsType>`
    ${({ variant }): SerializedStyles => setPriceLegendWrapper(variant, theme)}
    background-color: ${theme.star.priceLegendList.bgColor};
    color: ${theme.star.priceLegendList.txtColor};
    font-size: ${theme.star.fontSize.xSmall};
    font-weight: ${theme.star.fontWeight.regular};
    margin-top: -1px;
    position: relative;
`);

export const PriceLegend = styled('ul', { label: 'PriceLegend' })`
    line-height: 1;
`;

interface PriceLegendItemPropsType {
    itemColor: string;
}

export const PriceLegendItem = styled('li', { label: 'PriceLegendItem' })<PriceLegendItemPropsType>`
    display: inline-block;
    line-height: 1.4;
    margin-bottom: 9px;
    padding-left: 20px;
    position: relative;
    &:not(:last-of-type) {
        margin-right: 16px;
    }
    &::before {
        background-color: ${({ itemColor }): string => itemColor};
        bottom: 0;
        content: '';
        height: 16px;
        left: 0;
        margin: auto 0;
        position: absolute;
        top: 0;
        width: 16px;
    }
`;

export const InPlayRedirect = withConfig(theme => styled(Link, { label: 'InPlayRedirect' })`
    text-decoration: none;
    font-weight: ${theme.star.fontWeight.bold};
    margin-left: 4px;
`);

export const InPlayRedirectWrapper = styled('p', { label: 'InPlayRedirectWrapper' })`
    margin: 0 0 10px;
    line-height: 1.4;
`;
